import type { ReactElement } from 'react';
import { useLandingHeroImagesQuery } from '@/entities/landing-image';
import { SitePageShell } from '@/shared/ui';
import { AboutCompany } from '@/widgets/about-company';
import { AboutCta } from '@/widgets/about-cta';
import { AboutHero } from '@/widgets/about-hero';
import { AboutProcess } from '@/widgets/about-process';
import { AboutValues } from '@/widgets/about-values';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/**
 * 회사 소개(/about) — 첫 화면·하는 일·제작 과정·회사 정보·마무리 버튼을 차례로 쌓는다.
 * 첫 화면 사진은 HOME 히어로 배너의 첫 장을 다시 쓰고, 배너가 없거나 읽기에 실패하면 흑연 판이 대신한다.
 */
export const AboutPage = (): ReactElement => {
  const bannersQuery = useLandingHeroImagesQuery();
  const heroImageUrl = bannersQuery.data?.[0]?.imageUrl ?? null;

  return (
    <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
      <div className="flex flex-col gap-24 sm:gap-32">
        <AboutHero imageUrl={heroImageUrl} isImagePending={bannersQuery.isPending} />
        <AboutValues />
        <AboutProcess />
        <AboutCompany />
        <AboutCta />
      </div>
    </SitePageShell>
  );
};
